var path = '/common/sound.html';
var html = "<a class=\"sound\" ng-class=\"state\">\n  <fa name=\"<% icon() %>\" alt=\"<% icon() %>\"></fa>\n</a>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;